const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快爆料速度',
    desc: '7×24小时不间断追踪，从事件发生到深度报道最快仅需15分钟，让你永远走在吃瓜第一线。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '深度扒皮不遗漏',
    desc: '专业深扒团队层层挖掘，从蛛丝马迹到完整证据链，给你最详尽的吃瓜体验。',
  },
  {
    icon: 'ri-group-line',
    title: '百万瓜友真实互动',
    desc: '汇聚百万真实吃瓜群众，热门爆料下数千条真实评论，吃瓜不再孤独。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            三大核心优势，打造中文互联网最专业的吃瓜平台
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="p-6 md:p-8 bg-background-50 rounded-xl text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}